import { MENU_SCREEN } from "../../menu.types";
import { ShopItem } from "./shop.types";
import { FaClock } from "react-icons/fa";
import specialOfferBg from "./assets/images/special-offer-bg.webp";
import containerBg from "./assets/images/container-bg.webp";
import beginnerBg from "./assets/images/starter-bg-wide.webp";
import carIcon from "./assets/images/car-icon.webp";
import vipCardBg from "./assets/images/vip-card-bg.webp";
import vipIcon from "./assets/images/vip-icon.webp";
import clotchesBg from "./assets/images/clotches-bg.webp";
import clotchesIcon from "./assets/images/clotches-icon.webp";
import backpacksBg from "./assets/images/backpacks-bg.webp";
import backcpackIcon from "./assets/images/backpack-icon.webp";
import organizationsBg from "./assets/images/organizations-bg.webp";
import backpackSkinsIcon from "./assets/images/backpack-skins-icon.webp";
import backpackSkinsBg from "./assets/images/backpack-skins-bg.webp";
import premiumVehicleBg from "./assets/images/premium-vehicle-bg.webp";
import premiumVehicleIcon from "./assets/images/premium-vehicle-icon.webp";
import moneyPackageBg from "./assets/images/money-package-bg.webp";
import moneyIcon from "./assets/images/money-icon.webp";
import otherBg from "./assets/images/other-bg.webp";
import otherIcon from "./assets/images/other-icon.webp";
import voucherIcon from "./assets/images/voucher-icon.png";
import offerIcon from "../../assets/images/offer-icon.png";

export const SPECIAL_OFFER_ITEM = {
  id: "special-offer",
  name: "Oferta Speciala",
  description: "Pachet exclusiv cu timp limitat — vehicul premium + bonusuri.",
  backgroundImage: specialOfferBg,
  modalCoverImage:
    "https://i.ibb.co/fz2fW3Q4/da7e60fe-ac29-4e3e-a638-fb4a7115bca8-11zon.webp",
  icon: offerIcon,
  modalIcon: offerIcon,
  featured: true,
  apoints: 999,
  features: [
    { text: "10 zile 14 ore", icon: FaClock },
    { text: "Achizitioneaza" },
  ],
  /* perks: [
    "Vehicul premium exclusiv (Infernus Classic)",
    "Garaj privat pe 30 de zile",
    "x2 XP timp de 7 zile",
    "1000 $ in-game bonus",
    "Skin unic pentru vehicul",
  ], */
  textClassName: "text-left",
};

export const CONTAINERS_ITEM = {
  id: "containers",
  name: "Containere",
  description: "Open containers for random rewards.",
  backgroundImage: containerBg,
  screen: MENU_SCREEN.Containers,
  featured: true,
  textClassName: "text-center",
};

export const STARTER_PACK = {
  id: "starter-pack",
  name: "Pachet Incepator",
  description: "Perfect pack for new players.",
  backgroundImage: beginnerBg,
  textClassName: "text-right",
  featured: true,
  apoints: 149,
  perks: [
    "$50,000 bani in-game",
    "Masina de start (Sultan RS)",
    "x2 XP timp de 3 zile",
    "Kit supravietuire (arme + consumabile)",
    "Telefon mobil + GPS inclus",
  ],
};

export const SHOP_ITEMS: ShopItem[] = [
  // FEATURED

  SPECIAL_OFFER_ITEM,
  CONTAINERS_ITEM,
  STARTER_PACK,

  // GRID

  {
    id: "vip",
    name: "VIP",
    description: "Unlock exclusive VIP perks.",
    backgroundImage: vipCardBg,
    icon: vipIcon,
    screen: MENU_SCREEN.Vip,
  },
  {
    id: "clothes",
    name: "Haine",
    description: "Customize your character outfits.",
    backgroundImage: clotchesBg,
    icon: clotchesIcon,
    screen: MENU_SCREEN.Haine,
  },
  {
    id: "backpacks",
    name: "Ghiozdan",
    description: "Expand your inventory capacity.",
    backgroundImage: backpacksBg,
    icon: backcpackIcon,
    screen: MENU_SCREEN.Backpacks,
  },
  /**  {
    id: "organizations",
    name: "Organizatii",
    description: "Create or upgrade organizations.",
    backgroundImage: organizationsBg,
    icon: organizationsIcon,
    screen: MENU_SCREEN.Organizations,
  }, */
  {
    id: "vouchers",
    name: "Vouchers",
    description: "Create or upgrade vouchers.",
    backgroundImage: organizationsBg,
    icon: voucherIcon,
    screen: MENU_SCREEN.Vouchers,
  },
  {
    id: "backpack-skins",
    name: "Animatii",
    description: "Animații și emote-uri exclusive.",
    backgroundImage: backpackSkinsBg,
    icon: backpackSkinsIcon,
    screen: MENU_SCREEN.Animatii,
  },
  {
    id: "vehicles",
    name: "Vehicule Premium",
    description: "Purchase premium vehicles.",
    backgroundImage: premiumVehicleBg,
    icon: premiumVehicleIcon,
    screen: MENU_SCREEN.Vehicles,
  },
  {
    id: "money-packages",
    name: "Pachete Bani",
    description: "Get instant money packages.",
    backgroundImage: moneyPackageBg,
    icon: moneyIcon,
    screen: MENU_SCREEN.MoneyPackages,
  },
  {
    id: "other",
    name: "Altele",
    description: "Miscellaneous shop items.",
    backgroundImage: otherBg,
    icon: otherIcon,
    screen: MENU_SCREEN.Other,
  },
];

export const FEATURED_SHOP_ITEMS = SHOP_ITEMS.filter((i) => i.featured);
